(function () {
  var LAUNCH_TIMEZONE = 'Europe/Stockholm';

  function getTimezoneOffsetMinutes(date, timeZone) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      timeZoneName: 'shortOffset',
    });
    var parts = dtf.formatToParts(date);
    var offsetPart = parts.find(function (part) {
      return part.type === 'timeZoneName';
    });

    if (!offsetPart) return 0;

    var match = offsetPart.value.match(/GMT([+-]\d+)(?::(\d+))?/);
    if (!match) return 0;

    var hours = parseInt(match[1], 10);
    var minutes = match[2] ? parseInt(match[2], 10) : 0;
    var sign = hours < 0 ? -1 : 1;

    return hours * 60 + sign * minutes;
  }

  function getLaunchTargetMs(dateStr, timeStr) {
    var dateParts = (dateStr || '').split('-').map(Number);
    var timeParts = (timeStr || '00:00').split(':').map(Number);

    if (dateParts.length !== 3 || dateParts.some(isNaN)) return null;

    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];
    var hour = timeParts[0] || 0;
    var minute = timeParts[1] || 0;

    var naiveUtcMs = Date.UTC(year, month - 1, day, hour, minute, 0);
    var offsetMinutes = getTimezoneOffsetMinutes(new Date(naiveUtcMs), LAUNCH_TIMEZONE);

    return naiveUtcMs - offsetMinutes * 60000;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(el) {
    var targetMs = getLaunchTargetMs(el.dataset.launchDate, el.dataset.launchTime);
    if (targetMs === null) return;

    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');

    function update() {
      var remaining = targetMs - Date.now();

      if (remaining <= 0) {
        daysEl.textContent = '0';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        clearInterval(intervalId);
        return;
      }

      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      daysEl.textContent = days;
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    update();
    var intervalId = setInterval(update, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-prelaunch-countdown]').forEach(initCountdown);
  });
})();
